module.exports = __webpack_public_path__ + "img/Logo-zonder.8e06eb51.png";